import React from 'react';
import { Badge } from '@/components/ui/badge';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow
} from '@/components/ui/table';
import { History } from 'lucide-react';

// Edit Logs Tab — shows the audit trail of field-level changes on an export
// (old → new values per field, with author + timestamp).
export const EditLogsTab = ({ editLogs, formatDateTime }) => (
  <div className="space-y-4">
    <div className="flex items-center justify-between">
      <h3 className="text-lg font-medium text-white flex items-center gap-2">
        <History className="h-5 w-5 text-amber-400" />
        Edit History
      </h3>
      <Badge variant="outline" className="text-slate-400">
        {editLogs.length} changes
      </Badge>
    </div>

    {editLogs.length === 0 ? (
      <p className="text-slate-400 text-center py-8">Edit history will be shown here when changes are made.</p>
    ) : (
      <Table className="data-table">
        <TableHeader>
          <TableRow className="border-slate-800">
            <TableHead className="text-slate-400">Date/Time</TableHead>
            <TableHead className="text-slate-400">Field</TableHead>
            <TableHead className="text-slate-400">Old Value</TableHead>
            <TableHead className="text-slate-400">New Value</TableHead>
            <TableHead className="text-slate-400">Changed By</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {editLogs.map((log, index) => (
            <TableRow key={log.id || index} className="border-slate-800">
              <TableCell className="text-slate-300 text-xs font-mono">
                {formatDateTime(log.created_at)}
              </TableCell>
              <TableCell className="text-blue-400">{log.field_name}</TableCell>
              <TableCell className="text-red-400/70 max-w-[150px] truncate" title={log.old_value}>
                {log.old_value || '-'}
              </TableCell>
              <TableCell className="text-green-400 max-w-[150px] truncate" title={log.new_value}>
                {log.new_value || '-'}
              </TableCell>
              <TableCell className="text-slate-300">{log.changed_by_name || 'System'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )}

    <p className="text-sm text-slate-500">
      Showing {editLogs.length} edit{editLogs.length !== 1 ? 's' : ''}
    </p>
  </div>
);
